var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-xl": "", fluid: "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs8: "", "offset-xs2": "" } },
            [
              _c(
                "v-container",
                { attrs: { "grid-list-xl": "", fluid: "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _c("h1", { staticClass: "display-1" }, [
                          _vm._v("Installprice Management")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs6: "" } },
                        [
                          _c(
                            "v-card",
                            [
                              _c(
                                "v-container",
                                { attrs: { "grid-list-xl": "", fluid: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs12: "" } },
                                        [
                                          _c(
                                            "h2",
                                            { staticClass: "headline" },
                                            [_vm._v("Add Installprice")]
                                          ),
                                          _vm._v(" "),
                                          _c("v-text-field", {
                                            attrs: { label: "Type" },
                                            model: {
                                              value: _vm.type,
                                              callback: function($$v) {
                                                _vm.type = $$v
                                              },
                                              expression: "type"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-text-field", {
                                            attrs: { label: "Price" },
                                            model: {
                                              value: _vm.price,
                                              callback: function($$v) {
                                                _vm.price = $$v
                                              },
                                              expression: "price"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm.selected
                                            ? _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    large: "",
                                                    color: "primary"
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.updateInstallprice
                                                  }
                                                },
                                                [_vm._v("Update Installprice")]
                                              )
                                            : _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    large: "",
                                                    color: "primary"
                                                  },
                                                  on: {
                                                    click: _vm.addInstallprice
                                                  }
                                                },
                                                [_vm._v("Add Installprice")]
                                              )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs6: "" } },
                        [
                          _c(
                            "v-card",
                            [
                              _c(
                                "v-container",
                                { attrs: { "grid-list-xl": "", fluid: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs12: "" } },
                                        [
                                          _c("v-data-table", {
                                            attrs: {
                                              headers: _vm.headers,
                                              items: _vm.installprices
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "items",
                                                fn: function(props) {
                                                  return [
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(props.item.type)
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.item.price.toFixed(
                                                            2
                                                          )
                                                        ) +
                                                          " " +
                                                          _vm._s(
                                                            props.item.type &&
                                                              props.item
                                                                .type ===
                                                                "Shutter"
                                                              ? "per panel"
                                                              : ""
                                                          ) +
                                                          _vm._s(
                                                            props.item.type &&
                                                              props.item.type.includes(
                                                                "Curtain"
                                                              )
                                                              ? "per metre of track (width)"
                                                              : ""
                                                          )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _c(
                                                        "button",
                                                        {
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.editInstallprice(
                                                                props.item._id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("Edit")]
                                                      )
                                                    ])
                                                  ]
                                                }
                                              }
                                            ])
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-061822f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-061822f6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/InstallPrices.vue
// module id = null
// module chunks = 